import React from 'react';
import './Footer.css';
import { FaFacebookSquare, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { Col, FormControl, InputGroup, Row, Button } from 'react-bootstrap';
// import { Button } from 'bootstrap';
// FaFacebookSquare,FaInstagram,FaLinkedin
const Footer = () => {
    return (
        <div>
            <div className="text-light bg-dark p-5">
                <Row>
                    <Col>
                        <a className="text-light  fs-3" href="https://www.facebook.com/rezuanahaque.megha"><i className="fab fa-facebook-square"></i></a>
                        <a className="text-light  fs-3 ms-3" href="https://www.linkedin.com/in/rezuana-haque-42150418b/"><i className="fab fa-linkedin"></i></a>
                        <a className="text-light  fs-3 ms-3" href="https://www.instagram.com/_m__e__g__h__a_/"><i class="fab fa-instagram-square"></i></a>
                    </Col>
                    <Col>
                        <h5 className='text-warning'>Quick Links</h5>
                        <a className="text-light text-decoration-none" href="/home">Home</a><br />
                        <a className="text-light text-decoration-none" href="/aboutme">About me</a><br />
                        <a className="text-light  text-decoration-none" href="/projects">Projects</a><br />
                        {/* <a className="text-light text-decoration-none" href="/successstories">Success Stories</a> */}
                    </Col>
                    <Col>
                        © 2022 Rezuana Haque
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default Footer;